<template>
  <div>
    <vs-row class="a">
      <vs-list-header
        title="Notifications"
        style="font-size: 18px; font-weight: 100"
        color="dark"
      ></vs-list-header>
    </vs-row>
    <vs-table
      stripe
      v-model="selected"
      hoverFlat="false"
      max-height="280px"
      :data="lastAlert"
    >
      <template slot="thead">
        <vs-th v-for="item in headerAlert" :key="item">
          <vs-row>
            <vs-col
              id="noWrap"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              {{ item }}
            </vs-col>
          </vs-row>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          id="fontSizeData"
          :data="item"
          v-for="(item, i) in data"
          :key="item.i"
        >
          <vs-td style="width: 30vw" :data="item.alertname">
            <vs-row>
              <vs-col vs-type="flex" vs-align="center">
                <div v-if="item.alertstatus">
                  <vs-tooltip color="warning" text="Click to disarm">
                    <vs-icon
                      @click="disarm(aid[i])"
                      class="iconAvatarDis mr-3"
                      icon="notifications_active"
                    ></vs-icon
                  ></vs-tooltip>
                </div>
                <div v-else>
                  <vs-tooltip text="Tooltip Default">
                    <vs-icon
                      class="iconAvatar mr-3"
                      icon="notifications_active"
                    ></vs-icon
                  ></vs-tooltip>
                </div>

                <ul
                  @click="viewAlert(item, aid[i])"
                  class="p-0"
                  style="list-style-type: none; margin: 0"
                >
                  <li>
                    <span class="font-weight-bold mb-2">{{
                      item.alertname
                    }}</span>
                    # {{ item.alertid }}
                  </li>
                  <li>
                    <span class="w3-hide-small">
                      {{
                        $moment(item.timestamp).format(
                          "dddd, MMMM Do YYYY, h:mm:ss a"
                        )
                      }}</span
                    >
                    <span class="w3-hide-large w3-hide-medium">
                      {{
                        $moment(item.timestamp).format("YYYY-MM-DD HH:mm:ss")
                      }}</span
                    >
                  </li>
                </ul>

                <!-- <vs-button
                  size="small"
                  id="noWrap"
                  v-if="item.alertstatus"
                  @click="viewAlert(item, aid[i])"
                  color="danger"
                  type="filled"
                >
                  {{ item.alertname }}</vs-button
                >
                <vs-button
                  v-else
                  size="small"
                  id="noWrap"
                  @click="viewAlert(item, aid[i])"
                  color="primary"
                  type="filled"
                >
                  {{ item.alertname }}</vs-button
                > -->
              </vs-col>
            </vs-row>
          </vs-td>
          <!-- <vs-td :data="item.timestamp">
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                {{
                  $moment(item.timestamp).format(
                    "dddd, MMMM Do YYYY, h:mm:ss a"
                  )
                }}
              </vs-col></vs-row
            >
          </vs-td> -->

          <vs-td :data="item.sensorname" @click="sensorRoute(item.sensorname)">
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                <vs-button
                  v-if="item.alertstatus"
                  id="noWrap"
                  @click="viewSensor(item, aid[i])"
                  icon="signal_cellular_alt"
                  color="warning"
                  type="flat"
                  >{{ item.sensorname }}</vs-button
                >
                <vs-button
                  v-else
                  id="noWrap"
                  @click="viewSensor(item, aid[i])"
                  icon="signal_cellular_alt"
                  color="primary"
                  type="flat"
                  >{{ item.sensorname }}</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-td>
          <vs-td :data="item.timestamp">
            <vs-row vs-w="12">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                {{ item.message }}
              </vs-col></vs-row
            >
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- <vs-list v-for="item in alertlist" :key="item.message" class="w3-hide-medium w3-hide-large">
      <vs-list-item :title="item.alertname" subtitle="Top Contributor">
    <template slot="avatar">
      <vs-avatar />
    </template>z
  </vs-list-item></vs-list> -->
  </div>
</template>

<script>
export default {
  data: () => ({
    nwlist: [],
    sensorlist: [],
    network: "",
    selected: [],
    role: "",
    b: true,
    filtervalue: [],
    sensorlist: [],
    selectFilter: [],
    filter_input: [
      {
        alertname: "",
        alertid: "",
        message: "",
        sensorname: "",
        lastdata: "",
        timestamp: "",
        alertstatus: "",
      },
    ],
    filter_list: [],
    counter: 0,
    header: [
      "Disarm Button",
      "Alert Id",
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Reading Data",
      "Alert Timestamp",
      "Status",
    ],
    headerAlert: ["Alert Name", "Sensor Name", "Condition"],
    // alertlist: [{"name":"Temp Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45","status":true},
    // {"name":"Humid Alert","con":"Humidity > 60","sensname":"Humidity Sensor","data":"62%","timestamp":"2020-9-17 09:10:06","status":true}],
    alertlist: [],
    aid: [],
    sensorId: [],
    primeTable: [],
    dataBody: [],
    dataExport: [],
    dataAlert: [],
    dataIdSensor: "",
    dataActive: "",
    lastAlert: [],
    interval: "",
  }),
  methods: {
    disarm(id) {
      console.log(id);

      this.$http
        .get(this.$url2 + "disarm/" + this.$session.get("username") + "/" + id)
        .then(() => {
          this.$vs.notify({
            title: "Disarm",
            text: "Disarm this alert",
            color: "success",
            position: "top-center",
          });
          setTimeout(() => {
            location.reload();
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
          this.$vs.notify({
            title: "Disarm Error!",
            text: "Can't disarm this alert",
            color: "danger",
            position: "top-center",
            icon: "check",
          });
        });
    },
    handleSelected(item) {
      console.log(item);
      // this.dataIdSensor = id;
      // this.dataAlert = item;
      // console.log(this.dataAlert);
      // console.log(this.dataIdSensor);
      // this.$session.set("dataAlert", this.dataAlert);
      // this.$session.set("dataIdSensor", this.dataIdSensor);
      // this.$router.push({
      //   name: "ViewAlert",
      //   params: { dataAlert: this.dataAlert, dataIdSensor: this.dataIdSensor },
      // });
    },
    viewAlert(item, id) {
      //  console.log(item)
      this.dataIdSensor = id;
      this.dataAlert = item;
      console.log(this.dataAlert);
      console.log(this.dataIdSensor);
      this.$session.set("dataAlert", this.dataAlert);
      this.$session.set("dataIdSensor", this.dataIdSensor);
      this.$router.push({
        name: "ViewAlert",
        params: { dataAlert: this.dataAlert, dataIdSensor: this.dataIdSensor },
      });
    },
    viewSensor(item, id) {
      console.log(item);
      console.log(id);
      this.$API.get("sensors/user").then((result) => {
        let sensor = result.data.filter((sensor) => sensor.id == item.sensorid);
        if (sensor) {
          let item = sensor[0];
          this.$session.set("nwname", item.network);
          this.$session.set("statussensor", item.active);
          this.$session.set("nwid", item.nwid);
          this.$session.set("sensorname", item.name);
          this.$session.set("sensorid", item.serial_id);
          this.$session.set("gatewayid", item.gatewayid);
          this.$session.set("type", item.type);
          this.$session.set("lora", item.lora);
          this.$session.set("id", item.id);
          this.$router.push({
            name: "SensorDashboard",
            params: {
              // nwname: sensor.network,
              nwid: item.nwid,
              sensorid: item.serial_id,
              gatewayid: item.gatewayid,
              type: item.type,
              id: item.id,
            },
          });
        }
      });
    },
    async getAlertData() {
      var temp = [];
      var JSONcon;
      this.alertlist = [];
      temp = [];
      this.role = this.$session.get("role");
      console.log(this.role);
      var tempel = {};
      // this.$API.get('getalertlog/'+this.$session.get('username')).then((result) => {
      //   console.log(result.data)
      // })
      await this.$API.get("network/user").then((result) => {
        this.nwlist = result.data;
        this.nwlist.unshift({ id: 0, name: "All Network" });
        this.network = result.data[0].name;
      });
      await this.$API.get("sensors/user").then((result) => {
        this.sensorlist = result.data;
      });
      await this.$API.get("alertlog/user").then((result) => {
        console.log(result.data);
        result.data.forEach((element) => {
          JSONcon = JSON.parse(element.con);
          let sensor = this.sensorlist;
          // console.log(sensor);
          // let sensor = this.sensorlist.filter(
          //   (sensor) => sensor.name == element.sensorname
          // );
          if (sensor.length == 0) console.log("no sensor found");
          let count = 0;
          if (Array.isArray(element.alerthistory)) {
            element.alerthistory.forEach((el) => {
              count += 1;
              this.aid.push(element.id);
              this.sensorId.push(sensor[0].id);
              el.alertid = count;
              tempel = el;
              tempel.alertname = element.alertname;
              tempel.alertstatus = element.alertstatus;
              tempel.sensorname = JSONcon.loracon;
              // tempel.sensorname = "test"
              tempel.sensorid = sensor[0].id;
              this.alertlist.push(el);
              tempel = {};
            });
            let lastAlert =
              element.alerthistory[element.alerthistory.length - 1];
              // console.log(lastAlert)
            if (lastAlert.alertstatus == true) temp.push(lastAlert);
          } else {
            count += 1;
            this.aid.push(element.id);
            this.sensorId.push(sensor[0].id);
            element.alerthistory.alertid = count;
            tempel = element.alerthistory;
            tempel.alertname = element.alertname;
            tempel.alertstatus = element.alerthistory.alertstatus;
            tempel.sensorname = JSONcon.senname.name;
            tempel.sensorid = sensor[0].id;
            this.alertlist.push(element.alerthistory);
            tempel = {};
            let lastAlert =
              element.alerthistory[element.alerthistory.length - 1];
            // console.log(this.alertlist);
            temp.push(lastAlert);
          }
        });
        // console.log(temp);

        //Sort Alert By Date
        const sortByDate = (arr) => {
          const sorter = (a, b) => {
            //***********Sort Descending******************
            return (
              new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
            );
          };
          arr.sort(sorter);
        };
        sortByDate(this.alertlist);

        //Format Alert Date
        this.alertlist.forEach((element) => {
          element.timestamp = this.$moment(element.timestamp).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });

        //Insert Id
        let countId = 0;
        this.alertlist.forEach((element) => {
          element.alertid = countId;
          countId += 1;
        });
        // console.log(this.alertlist);

        //Set PrimeTable
        setTimeout(() => {
          this.lastAlert = temp;
        }, 100);
      }).catch((err) => {
        console.log(err)
      })
      this.interval = setTimeout(() => {
        this.getAlertData();
      }, 30000);
    },
  },
  async created() {
    this.getAlertData();
    // this.interval = setInterval(() => {
    //   this.getAlertData()
    // }, 30000);
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
};
</script>

<style scoped>
.iconAvatar {
  padding: 8px;
  background: rgba(var(--vs-primary), 0.08);
  color: #32c040;
  font-size: 20px;
  border-radius: 50%;
  margin-right: 15px;
}
.iconAvatarDis {
  padding: 8px;
  background: rgba(var(--vs-warning), 0.08);
  color: #ff911e;
  font-size: 22px;
  border-radius: 50%;
  margin-right: 15px;
}
.iconAvatarDis:hover {
  transform: translate(0, 4px);
}
/* style="background: rgba(var(--vs-primary),.08)" */
#noWrap {
  white-space: nowrap;
  font-size: 0.75rem;
}
.vs-button {
  border-radius: 20px;
}
.large-2::-webkit-scrollbar-track {
  border: 1px solid #000;
  padding: 2px 0;
  background-color: #404040;
}
</style>
